import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { brandColors } from "../../theme";

export const useAllocationContainerStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: "flex",
        },
        textContainer: {
            marginRight: theme.spacing(4),
        },
        textPrimary: {
            color: theme.palette.primary.main,
            marginLeft: theme.spacing(1),
        },
        statusModeType: {
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(2),
        },
        stepper: {
            backgroundColor: "inherit",
            paddingLeft: 0,
            paddingRight: 0,
            paddingBottom: theme.spacing(4),
            width: "calc(100% + 54px)",
            marginLeft: "-30px",
        },
        contentWithOverlay: {
            position: "relative",
            minHeight: 280,
        },
        loadingOverlay: {
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(255, 255, 255, 0.9)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 10,
        },
    })
);

export const useAllocationEditTableStyles = makeStyles((theme: Theme) =>
    createStyles({
        tableContainer: {
            overflowY: "auto",
            "& .MuiOutlinedInput-input": {
                ...theme.typography.caption,
            },
        },
        overviewPanel: {
            backgroundColor: theme.palette.common.white,
            marginLeft: theme.spacing(-3),
            marginRight: theme.spacing(-3),
            marginBottom: theme.spacing(-3),
        },
        table: {
            border: `1px solid ${theme.palette.grey[300]}`,
            "& .MuiTableBody-root .MuiTableRow-root:nth-child(odd)": {
                backgroundColor: theme.palette.grey[50],
            },
            "& .MuiTableCell-root": {
                border: `1px solid ${theme.palette.grey[300]}`,
                padding: theme.spacing(1),
                ...theme.typography.caption,
            },
            "& .MuiTableCell-head": {
                color: "inherit",
                ...theme.typography.caption,
                fontWeight: 500,
            },
        },
    })
);

export const useAllocationOverviewStyles = makeStyles((theme: Theme) =>
    createStyles({
        tableContainer: {
            overflowY: "scroll",
            padding: "0 24px 50px",
            maxHeight: "200px",
        },
        table: {
            border: `1px solid ${theme.palette.grey[300]}`,
            // "& .MuiTableBody-root .MuiTableRow-root:nth-child(odd)": {
            //   backgroundColor: theme.palette.grey[50],
            // },
            "& .MuiTableCell-root": {
                border: `1px solid ${theme.palette.grey[300]}`,
                padding: theme.spacing(1),
                ...theme.typography.body2,
            },
            "& .MuiTableCell-head": {
                color: "inherit",
                fontWeight: 500,
            },
        },
        bold: {
            fontWeight: "bold",
        },
        green: {
            backgroundColor: brandColors.success.bg,
        },
        darkGreen: {
            backgroundColor: brandColors.success.bright,
        },
        red: {
            backgroundColor: brandColors.secondary.bg,
        },
        yellow: {
            backgroundColor: brandColors.primary.light,
        },
        white: {
            backgroundColor: "#ffffff",
        },
    })
);

export const usePrevAllocatedStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            width: "100%",
        },
        content: {
            display: "flex",
        },
        noData: {
            width: "100%",
            height: "80px",
            border: `1px solid ${theme.palette.grey[200]}`,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        },
        noDataText: {
            color: theme.palette.grey[300],
        },
        sideGradient: {
            top: "0px",
            width: "34px",
            marginLeft: "-24px",
            background:
                "linear-gradient(90deg, rgb(255, 255, 255, 1) 30%, rgb(255, 255, 255, 0))",
            zIndex: 100,
        },
        sideButtons: {
            top: "0px",
            width: "80px",
            boxShadow: "-5px -5px 5px 0 rgba(30, 30, 30, 0.05)",
            color: theme.palette.primary.main,
            backgroundColor: "#FFF0F2",
            textAlign: "center",
            zIndex: 1,
        },
        sideButtonHead: { height: "75px", width: "70px" },
        sideButton: { height: "35px", width: "70px" },
        menu: {
            height: "300px",
            display: "flex",
            flexDirection: "column",
            padding: theme.spacing(1, 2),
            overflowY: "scroll",
        },
        menuTitle: {
            marginBottom: theme.spacing(2),
        },
        menuLabel: { color: theme.palette.primary.main },
        menuLabelSelected: {
            color: theme.palette.primary.main,
            fontWeight: "bold",
        },
        table: {
            minWidth: "550px",
        },
        tableWrapperSmart: {
            marginLeft: "-28px",
            paddingLeft: "19px",
            marginRight: "-2px",
            width: "100%",
            overflowX: "scroll",
        },
        tableWrapper: {
            width: "100%",
        },
        columnTitle: {
            fontSize: "12px",
            fontWeight: "bold",
        },
        visuallyHidden: {
            border: 0,
            clip: "rect(0 0 0 0)",
            height: 1,
            margin: -1,
            overflow: "hidden",
            padding: 0,
            position: "absolute",
            top: 20,
            width: 1,
        },
        textField: {
            margin: 0,
        },
        textFieldColored: {
            margin: 0,
            "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                borderColor: theme.palette.primary.main,
            },
            "& .MuiOutlinedInput-root:hover:not(.Mui-disabled):not(.Mui-focused):not(.Mui-error) .MuiOutlinedInput-notchedOutline":
                {
                    borderColor: theme.palette.primary.main,
                },
            "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: theme.palette.primary.main,
            },
        },
        toggleIcon: {
            borderRadius: "100%",
            margin: -5,
            padding: 0,
            marginLeft: 0.5,
            transition: "transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
        },
    })
);
